export default __webpack_public_path__ + "static/media/thumbs-up-filled.d47aa41b.svg";